export default __webpack_public_path__ + "about.3b60a279.svg";